import { BaseModel } from './BaseModel';

export class Modpack extends BaseModel {
    public platform = '';
    public id = '';
    public name = '';
    public description = '';
    public thumbnailUrl = '';
    public websiteUrl = '';
    public downloads = -1;
    public updatedAt = '';
}
